import { render, staticRenderFns } from "./MsArticleAddOrEdit.vue?vue&type=template&id=0577718a&scoped=true&"
import script from "./MsArticleAddOrEdit.vue?vue&type=script&lang=js&"
export * from "./MsArticleAddOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0577718a",
  null
  
)

export default component.exports